import { defineMessages } from 'react-intl';

export const calulatorMessages = defineMessages({
  basePrice: {
    id: 'ic-calculator-basePrice',
    defaultMessage: 'Preis',
  },
  firstInstallment: {
    id: 'ic-calculator-firstInstallment',
    defaultMessage: 'erste Rate',
  },
  fixedMonthlyInterestFactor: {
    id: 'ic-calculator-fixedMonthlyInterestFactor',
    defaultMessage: 'Fixer Sollzinssatz pro Monat',
  },
  installmentSurcharge: {
    id: 'ic-calculator-installmentSurcharge',
    defaultMessage: 'Ratenaufschlag**',
  },
  lastInstallment: {
    id: 'ic-calculator-lastInstallment',
    defaultMessage: 'Letzte Rate',
  },
  monthlyInstallment: {
    id: 'ic-calculator-monthlyInstallment',
    defaultMessage: 'Monatliche Rate',
  },
  monthlyInterestRateFactor: {
    id: 'ic-calculator-monthlyInterestRateFactor',
    defaultMessage: 'Ratenaufschlag pro Monat**',
  },
  overallPrice: {
    id: 'ic-calculator-overallPrice',
    defaultMessage: 'Dein Ratenkaufpreis',
  },
  paymentPauseSurcharge: {
    id: 'ic-calculator-paymentPauseSurcharge',
    defaultMessage: 'Zinsaufschlag für Zahlpause',
  },
  singleInstallment: {
    id: 'ic-calculator-singleInstallment',
    defaultMessage: '{numberOfRegularInstallments} Folgeraten je',
  },
  yearlyInterestRateFactor: {
    id: 'ic-calculator-yearlyInterestRateFactor',
    defaultMessage: 'Effektiver Jahreszins',
  },
});
